import styled from 'styled-components';

interface CheckProps {
  $check: boolean;
}

export const Container = styled.div<{ $isFocused: boolean }>`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  place-content: center;

  ${props =>
    props.$isFocused &&
    `
    &::after {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      right: -4px;
      bottom: -4px;
      border-radius: 4px;
      border: 2px solid #FF9800;
      pointer-events: none;
    }
  `}

  > input {
    border: 0;
    position: absolute;
    cursor: pointer;
    opacity: 0;
  }
`;

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

export const StyledCheckbox = styled.label<CheckProps>`
  display: inline-block;
  width: 1.11rem;
  height: 1.11rem;
  border: ${props => (props.$check ? '0' : '1px solid #e2e2e2')};
  background: ${props => (props.$check ? '#FF9800' : '#fff')};
  border-radius: 0.167rem;
  transition: all 0.3s;

  &:hover {
    border-color: #ff9800;
    box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.1);
  }

  ${Icon} {
    visibility: ${props => (props.$check ? 'visible' : 'hidden')};
  }
`;
